import { ContextMenu } from "@skilitics/designer-ui-components";
import type { FormatMessages } from "@skilitics/localization";
import { useFormatMessage } from "@skilitics/localization";
import type { SlotId } from "@skilitics/nautilus-core-designer-data";

import type { NodeSelectionCriteria } from "../../library";
import { BrowseTemplatesAndAddToSlotMenuItem } from "./menu-items/BrowseTemplatesAndAddToSlotMenuItem";
import { PasteToSlotMenuItem } from "./menu-items/PasteToSlotMenuItem";

interface Props {
  slotId: SlotId;
  slotDescriptor: NodeSelectionCriteria;
}

export const NodeTreeSlotActionsMenu = ({ slotId, slotDescriptor }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);
  return (
    <ContextMenu data-test="node-tree-context-menu">
      <PasteToSlotMenuItem slotId={slotId} criteria={slotDescriptor}>
        {formatMessage("pasteLabel")}
      </PasteToSlotMenuItem>
      <BrowseTemplatesAndAddToSlotMenuItem slotId={slotId} criteria={slotDescriptor}>
        {formatMessage("browseTemplatesLabel")}
      </BrowseTemplatesAndAddToSlotMenuItem>
    </ContextMenu>
  );
};

const formatStrings = {
  pasteLabel: {
    en: "Paste",
  },
  browseTemplatesLabel: {
    en: "Browse Templates",
  },
} satisfies FormatMessages;
